// extracted by mini-css-extract-plugin
export default {"Story":"StoryItem_Story__yJt7E","description":"StoryItem_description__G5LfL","button":"StoryItem_button__Xis7Q","sidediv":"StoryItem_sidediv__7BVS-"};